/* eslint-disable */
import { db } from '../main'

export default {
  namespaced: true,
  state: {
    orders: [],
    customer: {
      note: null,
      address: null
    },
    loading: false,
    itemLoading: false,
    error: null,
    requiredFields: [
      'branch',
      'cart',
      'customer',
      'delivery',
      'payment',
      'status',
      'total'
    ],
    updateFields: ['status', 'delivery', 'payment'],
    orderStatusValues: ['newOrder', 'processing', 'done'], // starting with newOrder
    deliveryStatusValues: ['delivering', 'done', 'cancel'], // starting with null/''
    paymentMethod: ['Cash', 'PaymentGateway'],
    startDate: '',
    filterBranch: '',
    sample: [
      {
        branch: 1,
        customer: {
          location: {
            address:
              '# 488 BC Eo, St. Moev Seng Toung, Sangkat Toek la ork I, Khan Toul kork, Phnom Penh',
            cord: {
              latitude: 11.569577,
              longitude: 104.773105
            }
          },
          phone: '+85578156378',
          note: '',
          name: 'Josh Vania'
        },
        cart: [
          {
            price: 10,
            measureUnit: 'L',
            name: 'Vegetarian Pizza',
            quantity: 2
          },
          {
            measureUnit: 'Can',
            name: 'Sprite',
            price: 0.5,
            quantity: 5
          }
        ],
        total: 22.5,
        delivery: {
          name: 'Mr. John',
          status: '',
          mode: 'takeAway',
          phone: '+85599879847'
        },
        timestamp: 'FIREBASE_TIMESTAMP_CLASS',
        status: 'newOrder',
        payment: {
          method: 'Cash',
          paid: false
        },
        documentId: 'FNxIxAz7EWCpycAYmLQR'
      }
    ]
  },
  mutations: {
    filterBranch(state, payload) {
      state.filterBranch = payload
    },
    orders(state, payload) {
      state.orders = payload || []
    },
    itemLoading(state, payload) {
      state.itemLoading = payload
    },
    loading(state, payload) {
      state.loading = payload
    },
    error(state, payload) {
      state.error = payload
    },
    startAction(state) {
      state.error = null
      state.loading = true
    },
    stopAction(state) {
      state.loading = false
    },
    startItemAction(state) {
      state.error = null
      state.itemLoading = true
    },
    changeLocalStatus(state, payload) {
      state.orders.forEach((order) => {
        if (order.documentId === payload.documentId) {
          order.status = payload.status
        }
      })
    },
    startDate(state, payload) {
      state.startDate = payload
    }
  },
  actions: {
    changeLocalStatus: ({ commit }, payload) => {
      commit('changeLocalStatus', payload)
    },
    /**
     * @func
     * @desc query all orders of a tenant regardless of branches
     *   this will invoke every time the document in the collection is updated
     *   by using onSnapshot listener
     *   If you create/update/delete an order, this function will also be invoked automatically
     *   so you don't have to update any client side store
     *   For the sake of the time being, I actually make it that way regardless of the cost
     *   we might have to spent. Future improvement can be done using pagination, and by not subscribing
     *   any listener
     * @param [context]
     */
    subscribeOrders(context) {
      context
        .dispatch('tenant/startIntervalDate', null, { root: true })
        .then((startIntervalStamp) => {
          console.log('interval', startIntervalStamp)
          db.collection('tenants')
            .doc(context.rootState.account.tenantId)
            .collection('orders')
            .where('timestamp', '>=', startIntervalStamp.timestamp)
            .onSnapshot((querySnapshot) => {
              let orders = []
              querySnapshot.forEach((snapshot) => {
                const data = snapshot.data()
                data.documentId = snapshot.id
                orders.push(data)
              })
              if (
                !context.rootGetters['account/isOwner'] &&
                context.rootGetters['tenant/branches'].length > 1
              ) {
                orders = orders.filter(
                  (x) => context.rootState.account.branchId.includes(x.branch)
                )
              }
              console.log('orders coming', orders)
              context.commit('orders', orders)
              context.commit('startDate', startIntervalStamp)
            })
        })
        .catch((error) => console.error(error))
    },

    /**
     * @func
     * @desc to update order from newOrder to processing state
     *   this function requires: payload.documentId
     *   If there is a delivery person/company name, just pass as
     *   payload.delivery.name, payload.delivery.phone
     * @param [context]
     * @param {Object} payload
     * @return {Promise<unknown>}
     */
    processOrder(context, payload) {
      return new Promise((resolve, reject) => {
        context.commit('startItemAction')
        if (!payload.documentId) {
          reject(new Error('payload.documentId is required'))
          return context.commit('stopAction')
        }
        const data = {
          status: context.state.orderStatusValues[1]
        }
        console.log(data)
        if (payload.delivery) {
          data['delivery.name'] = payload.delivery.name || ''
          data['delivery.phone'] = payload.delivery.phone || ''
          if (payload.delivery.fee) {
            data['delivery.fee'] = payload.delivery.fee || 0
          }
        }

        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .collection('orders')
          .doc(payload.documentId)
          .update(data)
          .then(() => {
            return resolve()
          })
          .catch((error) => {
            context.commit('error', error)
            return reject(error)
          })
          .finally(() => {
            context.commit('stopAction')
          })
      })
    },
    /**
     * @func
     * @desc to update delivery status from null to delivering
     *   this function requires: payload.documentId
     * @param [context]
     * @param {Object} payload
     * @return {Promise<unknown>}
     */
    processDelivery(context, payload) {
      return new Promise((resolve, reject) => {
        context.commit('startItemAction')
        if (!payload.documentId) {
          reject(new Error('payload.documentId is required'))
          return context.commit('stopAction')
        }
        const data = {
          'delivery.status': context.state.deliveryStatusValues[0]
        }

        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .collection('orders')
          .doc(payload.documentId)
          .update(data)
          .then(() => {
            return resolve()
          })
          .catch((error) => {
            context.commit('error', error)
            return reject(error)
          })
          .finally(() => {
            context.commit('stopAction')
          })
      })
    },

    /**
     * @func
     * @desc to move order from processing to done
     *   this function requires payload.documentId
     *   It will set payment.paid to true (you must check payment.paid in your UI Code)
     *   It will also set delivery.status to done as well
     * @param [context]
     * @param {Object} payload
     * @return {Promise<unknown>}
     */
    closingOrder(context, payload) {
      return new Promise((resolve, reject) => {
        context.commit('startItemAction')
        if (!payload.documentId) {
          reject(new Error('payload.documentId is required'))
          return context.commit('stopAction')
        }
        const data = {
          status: context.state.orderStatusValues[2],
          'delivery.status': context.state.deliveryStatusValues[1],
          'payment.paid': true
        }
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .collection('orders')
          .doc(payload.documentId)
          .update(data)
          .then(() => {
            return resolve()
          })
          .catch((error) => {
            context.commit('error', error)
            return reject(error)
          })
          .finally(() => {
            context.commit('stopAction')
          })
      })
    },

    /**
     * @func
     * @desc to update payment.paid to true after customer paid
     *   this function requires payload.documentId
     * @param [context]
     * @param {Object} payload
     * @return {Promise<unknown>}
     */
    paidOrder(context, payload) {
      return new Promise((resolve, reject) => {
        context.commit('startItemAction')
        if (!payload.documentId) {
          reject(new Error('payload.documentId is required'))
          return context.commit('stopAction')
        }
        const data = {
          'payment.paid': true
        }
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .collection('orders')
          .doc(payload.documentId)
          .update(data)
          .then(() => {
            return resolve()
          })
          .catch((error) => {
            context.commit('error', error)
            return reject(error)
          })
          .finally(() => {
            context.commit('stopAction')
          })
      })
    },
    /**
     * @func
     * @desc to cancel order. Change status to `cancel` and add `cancel` attribute
     *   this function requires payload.documentId and payload.cancel.reason
     * @param [context]
     * @param {Object} payload
     * @return {Promise<unknown>}
     */
    cancelOrder(context, payload) {
      return new Promise((resolve, reject) => {
        context.commit('startItemAction')
        if (!payload.documentId && !payload.cancel.reason) {
          reject(
            new Error(
              'payload.documentId and payload.cancel.reason are required'
            )
          )
          return context.commit('stopAction')
        }
        const data = {
          status: 'cancel',
          'cancel.reason': payload.cancel.reason,
          'cancel.desc': payload.cancel.desc,
          'delivery.status': context.state.deliveryStatusValues[2]
        }
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .collection('orders')
          .doc(payload.documentId)
          .update(data)
          .then(() => {
            return resolve()
          })
          .catch((error) => {
            context.commit('error', error)
            return reject(error)
          })
          .finally(() => {
            context.commit('stopAction')
          })
      })
    },
    editCustomer (context, payload) {
      if (typeof payload.note === "undefined"){
        payload.note = null
      }
      if (typeof payload.address === "undefined") {
        payload.address = null
      }
        return new Promise((resolve, reject) => {
          db.collection('tenants')
            .doc(context.rootState.account.tenantId)
            .collection('orders')
            .doc(payload.documentId)
            .update({"customer.location.address":payload.address, "customer.note":payload.note} )
            .then(() => {
              return resolve()
            })
            .catch(error => {
              return reject(error)
            })
        })
    },
    assignBranch (context, payload) {
      return new Promise((resolve, reject) => {
        context.commit('startItemAction')
        if (!payload.documentId) {
          reject(new Error('payload.documentId is required'))
          return context.commit('stopAction')
        }
        if (typeof payload.branch === "undefined") {
          payload.branch = ""
        }
        const data = {
          'branch': payload.branch
        }
        db.collection('tenants')
          .doc(context.rootState.account.tenantId)
          .collection('orders')
          .doc(payload.documentId)
          .update(data)
          .then(() => {
            return resolve()
          })
          .catch((error) => {
            context.commit('error', error)
            return reject(error)
          })
          .finally(() => {
            context.commit('stopAction')
          })
      })
    },

  },
  getters: {
    orderAfterFilter(state) {
      if (!state.orders || state.orders.length < 1) {
        return []
      }
      return state.orders.filter((x) => {
        if (!state.filterBranch) {
          return true
        }
        if (x.branch) {
          return x.branch
            .toLowerCase()
            .includes(state.filterBranch.toLowerCase())
        }
        return false
      })
    },
    todayOrder(state, getters) {
      if (!getters.orderAfterFilter || getters.orderAfterFilter.length < 1) {
        return []
      }
      const today = new Date()
      const startDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
        0,
        0,
        0
      )
      const endDate = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 1,
        0,
        0,
        0
      )
      return getters.orderAfterFilter.filter(
        (x) =>
          x.timestamp.toDate() >= startDate && x.timestamp.toDate() < endDate
      )
    },
    newOrder(state, getters) {
      if (!getters.orderAfterFilter || getters.orderAfterFilter.length < 1) {
        return []
      }
      return getters.orderAfterFilter.filter((x) => x.status === 'newOrder')
    },
    thisMonthOrder(state, getters) {
      if (!getters.orderAfterFilter || getters.orderAfterFilter < 1) {
        return 0
      }
      return getters.orderAfterFilter.length
    }
  }
}
